(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !window.DesignMode) return;
  try {
    
  {{ 'faq-accordion.js' | asset_url | script_tag }}

  } catch(e) { console.error(e); }
})();
})();
